import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { requestDataCliente } from "../../actions/cliente";
import { Alert, Stack } from "@mui/material";
import { Grid, makeStyles } from "@material-ui/core";
import { useParams } from "react-router-dom";
import ListadoDescuentos from "../home/descuentos";
import Tienda from "./tienda";
import colores from "../../shared/constants/styles";
import VendedorCard from "./vendedorCard";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ContactoCard from "./contactoCard";

const useStyles = makeStyles((theme) => ({
  PDato: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: "2vh",
  },
  PDatoCliente: {
    fontSize: 18,
    fontWeight: "bold",
    color: "gray",
    margin: "0px",
  },
  OficialBack: {
    backgroundColor: "pink",
  },
}));

const ClienteVendedor = (props) => {
  const style = useStyles();
  let { id } = useParams();
  const [successEnviado, setSuccessEnviado] = useState(false);
  const [errorEnviado, setErrorEnviado] = useState(false);

  useEffect(() => {
    props.requestDataCliente(id);
  }, []);

  useEffect(() => {
    if (props.cliente.numero) {
    }
  }, [props.cliente]);

  const getIdentificacion = (tipoDocumentoId) => {
    switch (tipoDocumentoId) {
      case "1":
        return "CUIL";
      case "2":
        return "DNI";
      case "3":
        return "CUIT";
      default:
        break;
    }
  };

  return (
    <>
      {
        <div className="container">
          <div style={{ marginTop: "7rem", marginLeft: "1rem" }}>
            <p
              style={{
                fontWeight: "bold",
                fontSize: "2.1875rem",
                marginBottom: "4rem",
              }}
            >
              Perfil de cliente: {props.cliente?.nombre}
            </p>
          </div>
          <div style={{ marginLeft: "1rem" }}>
            <div className="container" style={{ marginBottom: "5rem" }}>
              <div className="row">
                <div className="col-sm-2" style={{ margin: "4vh" }}>
                  <div
                    style={{
                      borderRadius: "50%",
                      width: "5vw",
                      height: "5vw",
                      backgroundColor: colores.azulOscuro,
                    }}
                  >
                    <PersonOutlineOutlinedIcon
                      style={{
                        fill: "white",
                        width: "3vw",
                        height: "3vw",
                        margin: "1vw",
                      }}
                    />
                  </div>
                </div>
                <div
                  class="col-sm-1"
                  style={{
                    borderLeft: "2px solid",
                    borderLeftColor: colores.azulOscuro,
                    height: "200px",
                  }}
                ></div>

                <div className="col-sm-4">
                  <p className={style.PDatoCliente}>N° de usuario: </p>
                  <p className={style.PDato}>{id}</p>
                  <p className={style.PDatoCliente}>Nombre: </p>
                  <p className={style.PDato}>{props.cliente?.nombre}</p>
                </div>
                <div className="col-sm-4">
                  <p className={style.PDatoCliente}>Tipo de documento: </p>
                  <p className={style.PDato}>
                    {props.cliente?.tipodocumento
                      ? getIdentificacion(props.cliente?.tipodocumento)
                      : "-"}
                  </p>
                  <p className={style.PDatoCliente}>N°: </p>
                  <p className={style.PDato}>{props.cliente?.numero}</p>
                </div>
              </div>
            </div>
            <div className="container">
              <p style={{ fontSize: "2.1875rem", fontWeight: "bold" }}>
                Contactos
              </p>
              <div className="d-flex flex-wrap">
                <Grid container spacing={3} className="d-flex">
                  {props.cliente.contactos?.$values.length >= 0 &&
                    props.cliente.contactos?.$values?.map((contacto) => (
                      <ContactoCard
                        clienteId={id}
                        id={contacto.id}
                        nroDocumento={props.cliente.numero}
                        nombre={contacto.nombre}
                        email={contacto.email}
                        contactoNro={contacto.contactoNro}
                        createDate={contacto.createDate}
                        enviadoEmail={contacto.enviadoEmail}
                        primerInicio={contacto.primerInicio}
                        setSuccessEnviado={setSuccessEnviado}
                        setErrorEnviado={setErrorEnviado}
                      />
                    ))}
                </Grid>
              </div>
            </div>
            <div className="container">
              <p style={{ fontSize: "2.1875rem", fontWeight: "bold" }}>
                Vendedores
              </p>
              <div className="d-flex flex-wrap">
                <Grid container spacing={5} className="d-flex">
                  <VendedorCard
                    title={"Oficial de cuenta"}
                    nombre={props.cliente.oficialDeCuenta?.apellidoNombre}
                    email={props.cliente.oficialDeCuenta?.email}
                    telefono={props.cliente.oficialDeCuenta?.telefono}
                  />
                  {props.cliente.vendedoresStaff?.$values.length >= 0 &&
                    props.cliente.vendedoresStaff?.$values?.map((staff) => (
                      <VendedorCard
                        title={"Vendedores Staff"}
                        nombre={staff.apellidoNombre}
                        email={staff.email}
                        telefono={staff.telefono}
                      />
                    ))}
                </Grid>
              </div>
            </div>
            <div className="container">
              <p style={{ fontSize: "2.1875rem", fontWeight: "bold" }}>
                Tiendas
              </p>
              <div className="d-flex flex-wrap">
                <Grid container spacing={5}>
                  {props.cliente.tiendas?.$values.map((tienda) => (
                    <Tienda key={tienda.tiendaNro} data={tienda} />
                  ))}
                </Grid>
              </div>
            </div>
            <div className="container">
              <p style={{ fontSize: "2.1875rem", fontWeight: "bold" }}>
                Descuentos
              </p>
              <div style={{ marginBottom: "2vw" }}>
                <ListadoDescuentos
                  key={id}
                  data={props.cliente.reglaDescuento?.$values}
                  title={"Descuento Comercial"}
                />
              </div>
              <div style={{ marginBottom: "2vw" }}>
                <ListadoDescuentos
                  key={id}
                  data={props.cliente.reglaDescuentoDetalle?.$values}
                  title={"Descuento por familia de productos"}
                />
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default connect(
  (state) => ({
    cliente: state.clientes.cliente,
    loading: state.clientes.loading,
  }),
  (dispatch) => ({
    requestDataCliente: (id) => dispatch(requestDataCliente(id)),
  }),
)(ClienteVendedor);
